/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tx_Status_PendingInputs */

const en_tx_status_pending = /** @type {(inputs: Tx_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

const id_tx_status_pending = /** @type {(inputs: Tx_Status_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menunggu`)
};

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Tx_Status_PendingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tx_status_pending = /** @type {((inputs?: Tx_Status_PendingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tx_Status_PendingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tx_status_pending(inputs)
	return en_tx_status_pending(inputs)
});